module.exports = __webpack_public_path__ + "static/media/marker--single.bbdbcc94.svg";